import React from 'react';

import PropTypes from 'prop-types';

import A from 'wanderu-component-react-router-link';
import {
    MarkdownContent,
    PageSection,
    SectionTitle,
} from 'wanderu-components';

import {
    CHIKU_IMAGE,
    CHIKU_URL,
} from '../../constants';

import aboutUsStyles from '../AboutUs/AboutUs.scss';
import styles from './ChikuSection.scss';

const propTypes = {
    description: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
};

function ChikuSection(props) {
    const {
        buttonLabel,
        description,
        title,
    } = props;

    return (
        <PageSection
            aria-labelledby="chiku-section"
            className={styles.chikuSection}
            layoutClassName={styles.chikuSectionLayout}
        >
            <SectionTitle id="chiku-section">
                {title}
            </SectionTitle>
            <img
                alt=""
                className={styles.chikuImage}
                src={CHIKU_IMAGE}
            />
            <MarkdownContent
                className={styles.chikuDescription}
            >
                {description}
            </MarkdownContent>
            <A
                className={`${styles.chikuButton} ${aboutUsStyles.aboutUsButton}`}
                href={CHIKU_URL}
                native
            >
                {buttonLabel}
            </A>
        </PageSection>
    );
}

ChikuSection.propTypes = propTypes;

export default ChikuSection;
